import { FeedItem, FeedSection } from '../../Api'

export const feedMappingConfig = {
  trending: (sections: FeedSection[]) =>
    sections.find((section) => section.location === 'S1') || null,
  headlines: (sections: FeedSection[]) =>
    sections.find((section) => section.tags.includes('headlines')) || null,
  latest: (sections: FeedSection[]) =>
    sections.find((section) => section.tags.includes('latest')) || null,
  S2: (sections: FeedSection[]) =>
    sections.find(
      (section) => section.location === 'S2' && !section.tags.includes('trending')
    ) || null,
  S3: (sections: FeedSection[]) =>
    sections.find(
      (section) => section.location === 'S3' && !section.tags.includes('trending')
    ) || null,
  S4: (sections: FeedSection[]) =>
    sections.find(
      (section) => section.location === 'S4' && !section.tags.includes('trending')
    ) || null,
  S5: (sections: FeedSection[]) =>
    sections.find((section) => section.location === 'S5') || null,
  team: (sections: FeedSection[]) =>
    sections.find((section) => section.location === 'team') || null,
} as const

export const getPartnerLabel = (feedItem: FeedItem) => {
  if (feedItem.partnerId) return feedItem.partnerId
  if (feedItem.tags?.find((tag) => tag === 'wll')) return 'WLL'
  return null
}

export const deduplicateFeedItems = (items: FeedItem[]): FeedItem[] => {
  const seen = new Set<string>()
  return items.filter((item) => {
    if (!item.id) {
      return true
    }
    if (seen.has(item.id)) {
      return false
    }
    seen.add(item.id)
    return true
  })
}
